export interface ExtendedJobseekerDetails {
  jobseekerId: number;
  name: string;
  surname: string;
  email: string;
  phoneNumber: string;
  phoneNumber2: string;
  address: string;
  legalAddress: string;
  isVehicleOwner: string;
  gender: string;
  genderName: string;
  dateOfBirth: string;
  jobseekerPhoto: string;
  extendedLocations: string[];
  drivingLicenses: string[];
  vehicleTypes: string[];
  hardSkills: SkillItem[];
  softSkills: SkillItem[];
  Languages: LanguageItem[];
  workExperiences: WorkExperienceItem[];
  documents: DocumentItem;
  EducationItem: EducationItem;
  totalWorkExperienceInMonth: string;
}
export interface LanguageItem {
  worldLanguageId: number;
  name: string;
  languageProficiencyLevel: string;
  filename: string;
}

export interface LanguageChanges {
  attachment?: string;
  createDate?: Date;
  jobseekerId: number;
  jobseekerLanguageId: number;
  languageProficiencyLevel: LanguageProficiency;
  worldLanguage: WorldLanguage;
}

export interface LanguageProficiency {
  languageProficiencyLevelId: number;
  name: string;
  rankId: number;
}

export interface JobseekerLanguageChanges {
  addedLanguages?: LanguageChanges[];
  changedLanguages?: LanguageChanges[];
  removedLanguages?: LanguageChanges[];
}

export interface WorldLanguage {
  createDate: Date;
  createUserId: number;
  lastChangeDate?: Date;
  lastChangeUserId: number;
  name: string;
  worldLanguageId: number;
}
export interface WorkExperienceItem {
  JobseekerWorkExperienceId?: number;
  employmentPeriod: string;
  employer: string;
  positionTitle: string;
  description: string;
  jobseekerFile: string;
  occupationCategories: OccupationCategoryItem[];
  workExperienceInMonth: string;
}

export interface WorkExperienceChanges {
  attachment?: string;
  categories?: OccupationCategoryItem[];
  createDate?: Date;
  dateFromMonth: number;
  dateFromYear: number;
  dateToMonth: number;
  dateToYear: number;
  description: string;
  employer: string;
  isCurrent: boolean;
  isLast: boolean;
  jobseekerId: number;
  jobseekerWorkExperienceId: number;
  objectId?: string;
  positionTitle: string;
  workExperienceMonths: number;
  workExperienceInMonths: number;
}

export interface JobseekerWorkExperienceChanges {
  addedWorkExperiences?: WorkExperienceChanges[];
  removedWorkExperiences?: WorkExperienceChanges[];
  changedWorkExperiences?: WorkExperienceChanges[];
}
export interface OccupationCategoryItem {
  occupationCategoryId: number;
  Name: string;
  children: OccupationCategoryItem[];
}
export interface DocumentItem {
  jobseekerDocumentId: number;
  name: string;
  descriptio: string;
  filename: string;
}
export interface EducationItem {
  jobseekerEducationId?: number;
  jobseekerFile: string;
  educationLevel: string;
  institution: string;
  educationalProgramName: string;
  specialization: string;
  description: string;
  educationInMonths: number;
}

export interface SkillItem {
  userProvidedText: string;
  canonicalSkillId: string;
  name: string;
  source: number;
  index: number;
}

export interface JobseekerInfoSkill {
  userProvidedText: string;
  canonicalSkillId: string;
  source: number;
  index: number;
}

export interface JobseekerInfoSkillViewModel {
  skillId: string;
  userProvidedText: string;
  name: string;
  source: number;
  index: number;
}

export interface JobseekerSkillChanges {
  addedSkills?: JobseekerInfoSkill[];
  removedSkills?: JobseekerInfoSkill[];
  changedSkills?: JobseekerInfoSkill[];
  removedSkillViewModels?: JobseekerInfoSkillViewModel[];
}

export interface JobseekerModeratienViewModel {
  changes: number[];
  isCreate: boolean;
  jobseekerModerationId: string;
  editedJobseeker: ExtendedJobseekerDetails;
  originalJobseeker: ExtendedJobseekerDetails;
}

export interface JobseekerChangesModel {
  entityAttributes: number[];
  jobseekerDocumentChanges: DocumentChanges;
  jobseekerWorkExperienceChanges: JobseekerWorkExperienceChanges;
  jobseekerEducationChanges: JobseekerEducationChanges;
  jobseekerLanguageChanges: JobseekerLanguageChanges;
  jobseekerHardSkillChanges: JobseekerSkillChanges;
  jobseekerSoftSkillChanges: JobseekerSkillChanges;
}

export interface DocumentChanges {
  addedDocuments?: DocumentItemModel[];
  deletedDocuments?: DocumentItemModel[];
}

export interface DocumentItemModel {
  contentType?: string;
  createDate: Date;
  description?: string;
  filename: string;
  isDeleted: boolean;
  jobSeekerDocumentId: number;
  jobSeekerId: number;
  label: string;
  lastChangeDate?: string;
  type: number;
}

export interface JobseekerEducationChanges {
  addedEducations: JobSeekerEducationItem[];
  changedEducations: JobSeekerEducationItem[];
  removedEducations: JobSeekerEducationItem[];
}

export interface JobSeekerEducationItem {
  attachment: string;
  createDate: string;
  dateFromMonth: number;
  dateFromYear: number;
  dateToMonth: number;
  dateToYear: number;
  description: string;
  educationLevel: EducationLevel;
  educationalInstitution: EducationInstitution;
  educationalProgram: number;
  educationalProgramName: string;
  institution: string;
  jobseekerEducationId: number;
  jobseekerId: number;
  objectId?: string;
  specialization: string;
}

export interface EducationLevel {
  educationLevelId: number;
  name: string;
  createDate: Date;
  createUser?: string;
  lastChangeDate?: Date;
  lastChangeUser?: string;
  rankId: number;
}

export interface jobseekerModerationRequest {
  JobseekerModerationId: string;
  ContactResetMap: { [key: string]: string };
  WorkExperienceResetMap: { [key: string]: string };
  EducationResetMap: { [key: string]: string };
  DocumentResetMap: { [key: string]: string };
  LanguageResetMap: { [key: string]: string };
  SkillResetMap: { [key: string]: string };
}

export interface EducationInstitution {
  code?: string;
  createDate: Date;
  displayName?: string;
  educationalInstitutionId: number;
  endDate?: Date;
  isActive: boolean;
  logoFileName?: string;
  name?: string;
  latinName?: string;
  startDate?: Date;
}

export enum JobseekerModerationAttributeEnum {
  Name = 1,
  Surname = 2,
  Email = 3,
  PhoneNumber = 4,
  PhoneNumber2 = 5,
  Gender = 6,
  DateOfBirth = 7,
  Locality = 8,
  ExtendedLocationId = 9,
  Address = 10,
  LegalAddress = 12,
  DrivingLicense = 13,
  IsVehicleOwner = 14,
  VehicleType = 15,
  Photo = 16,
  WorkExperience = 17,
  Education = 18,
  Language = 19,
  Attachment = 20,
  IsWorkExperienceFilled = 21,
  TotalWorkExperienceInMonths = 22,
  HardSkill = 23,
  SoftSkill = 24,
}
export interface RejectModel {
  key: number;
  value: string;
}
